import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/empiriecom/core/frontend/turborepo/apps/order/src/app/[lang]/(shop)/warenkorb/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/builds/empiriecom/core/frontend/turborepo/packages/shared/src/ui/ErrorBoundary/ErrorBoundary.tsx");
